import type { BooleanFlag, Channel, GeneralID } from './baseTypes';

export enum LibType {
  pano = 'pano',
  panoVideo = 'panoVideo',
  matrix = 'matrix',
  image = 'image',
  video = 'video',
  audio = 'audio',
  sequenceFrame = 'sequenceFrame',
  doc = 'doc',
}

/** 接口用 0其他，1音频，2图片，3视频, 4环物 5文档 */
export enum LibApiType {
  other = 0,
  audio = 1,
  image = 2,
  video = 3,
  seqFrame = 4,
  doc = 5,
}

export type LibUploadingItem = {
  id: GeneralID;
  name: string;
  libId?: number;
  progress: string;
};

export type LibUploadingMap = Map<GeneralID, LibUploadingItem>;

export type LibItemAlbum = {
  createDate: number;
  id: number;
  name: string;
  parent?: { id: number; name: string };
  updateDate: number;
  operatorId?: number;
  operatorName?: string;
};

export type LibAlbumResp = {
  children: LibItemAlbum[];
  createDate: number;
  id: number;
  name: string;
  parentId: number;
  updateDate: number;
};

type SceneItemCommon = {
  album?: { id: number; name: string };
  cdnDomain: number;
  channel: Channel;
  subChannel: string;
  remark: string;
  createDate: number;
  id: number;
  name: string;
  updateDate: number;
  operatorId?: number;
  operatorName?: string;
};

type ImageItemCommon = SceneItemCommon & {
  city: string;
  country: string;
  exif: string; // '{}'
  gps: string; // '{}'
  keywords: string;
  mapLocation: string; // '{}'
  multires: string; // '{}'
  province: string;
  watermarked: BooleanFlag;
};

export type LibItemPano = ImageItemCommon & {
  blockchain: BooleanFlag; // 0:没有存证 1:已经存证
  method: 0 | 1 | 2 | 3; // 0: '单反',1: '航拍',2: '3D建模', 3: '一键拍摄设备'
  path: string;
  qiniuThumbUrl: string;
  north: number;
};

export type LibItemPVideo = SceneItemCommon & {
  /** 0未处理 1处理中 2成功 3失败 */
  status: 0 | 1 | 2 | 3;
  thumbUrl: string;
  transcodeTrack: string;
  /** 原画画质, v5.7.5更新 */
  originTrack?: string;
};

export type LibItemMatrix = ImageItemCommon & {
  fov: string;
  geocode: string;
  path: string;
  thumbUrl: string;
};

export type LibItemScene = LibItemPano | LibItemPVideo | LibItemMatrix;

export type LibItemMedia = {
  album?: { id: number; name: string };
  createDate: number;
  duration: number;
  frame: number; // 环物用
  id: number;
  name: string;
  suffix: string; // 环物用
  updateDate: number;
  url: string;
  subtitle: string;
  thumb?: string;
  operatorId?: number;
  operatorName?: string;
};

export type LibItemScrollList = LibItemScene | LibItemMedia;

export type LibItemSysImage = {
  id: number;
  name: string;
  url: string;
};

export type LibItemSysAudio = {
  id: number;
  name: string;
  url: string;
  duration: number;
  copyright: string; // 版权来源
  free: BooleanFlag; // 0付费，1免费
  createDate: number;
  updateDate: number;
};

export type LibItemArticle = {
  id: number;
  thumb: string;
  title: string;
  text: string;
  createDate: number;
  updateDate: number;
  album?: { id: number; name: string };
  operatorId?: number;
  operatorName?: string;
};

export type LibStorage = {
  levelStorage: number;
  shoppingStorage: number;
  usedStorage: number;
};

export type LibItemSysIcon = {
  url: string;
  frame: number;
};

export type LibItemModal3d = {
  id: number;
  tid: string;
  name: string;
  thumbUrl: string;
  createDate: number;
  updateDate: number;
  // 0:待审核 1:审核成功 2:审核失败
  status: 0 | 1 | 2;
};

export type LibPanoCache = {
  id: number;
  name: string;
  path: string;
  /** "{}" */
  multires: string;
  cdnDomain: number;
  qiniuThumbUrl: string;
  createDate: number;
  updateDate: number;
};

export type LibMatrixCache = {
  id: number;
  name: string;
  thumb: string;
  /** "{}", */
  mapLocation: string;
  /** "{}" */
  fov: string;
  /** "{}" */
  multires: string;
  path: string;
  cdnDomain: number;
  createDate: number;
  updateDate: number;
};
